import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function RecipientTooltipTitle({
  iconName
}) {
  switch (iconName) {
    case 'replyAll':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.recipient-tooltip-title.reply-all"
      });
    case 'forward':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.recipient-tooltip-title.forward"
      });
    case 'reply':
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.metadata-editor.recipient-tooltip-title.reply"
      });
  }
}
RecipientTooltipTitle.displayName = 'RecipientTooltipTitle';